import React from 'react';
import List from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/List';
import ListItem from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/ListItem';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import DocumentListSkeleton from 'Components/UI/DocumentList/Skeleton';
import { hasRelationship } from 'Helpers/Affordances';
import fr from 'facet-rest';
import ListItemIcon from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/ListItemIcon';
import FontAwesome from 'Components/UI/FontAwesome/FontAwesome';
import { fileIcon } from 'Helpers/File';
import ListItemText from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/ListItemText';
import ListItemSecondaryAction
  from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/ListItemSecondaryAction';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { IconButton } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4';
import { RemoveRedEye } from '@material-ui/icons';
import DeleteIcon from '@material-ui/icons/Delete';
import { noop } from 'Helpers/PropTypes';

const DocumentList = ({
  classes,
  documentCollection,
  onSubmit,
  onDelete,
  onError,
  onFinally,
}) => {
  if (!documentCollection) {
    return <DocumentListSkeleton />;
  }
  return (
    <List classes={{ root: classes.root }}>
      {documentCollection.resources()
        .list()
        .map(fo => {
          const canPost = fo.id() > 0 && fo.meta()?.action('POST');
          const canDelete = fo.id() > 0 && fo.meta()?.action('DELETE');
          const canDownload = hasRelationship(fo, fr.relationships.download.name);

          const handleDelete = canDelete ? async (e) => {
            try {
              e.preventDefault();
              await fo.delete();
              onDelete();
            } catch (err) {
              onError(err);
            } finally {
              onFinally();
            }
          } : undefined;

          const onClick = canPost ? async (e) => {
            try {
              e.preventDefault();
              await fo.submit();
              onSubmit();
            } catch (err) {
              onError(err);
            } finally {
              onFinally();
            }
          } : undefined;

          return (
            <ListItem classes={{ root: classes.listItem }} button={!!canPost} key={fo.id()} onClick={onClick}>
              <ListItemIcon classes={{ root: classes.icon }}>
                <FontAwesome
                  icon={fileIcon(fo.attr('name'))}
                  fontSize="24px"
                />
              </ListItemIcon>
              <ListItemText color="primary">
                {fo.attr('name')}
              </ListItemText>
              <ListItemSecondaryAction>
                <Box>
                  {canDownload && (
                    <a
                      rel="noopener noreferrer"
                      target="_blank"
                      href={fo.relationship(fr.relationships.download.name)
                        .link('related')
                        .url()}
                      download
                    ><IconButton size="small" edge="start" icon={RemoveRedEye} color="primary" />
                    </a>
                  )}
                  {canDelete && <IconButton onClick={handleDelete} edge="end" icon={DeleteIcon} size="small" color="error" />}
                </Box>
              </ListItemSecondaryAction>
            </ListItem>
          );
        })}
    </List>
  );
};

DocumentList.defaultProps = {
  documentCollection: null,
  onSubmit: noop,
  onDelete: noop,
  onFinally: noop,
  onError: noop,
};

DocumentList.propTypes = {
  classes: PropTypes.object.isRequired,
  documentCollection: PropTypes.object,
  onFinally: PropTypes.func,
  onSubmit: PropTypes.func,
  onDelete: PropTypes.func,
  onError: PropTypes.func,
};

export default withStyles(theme => ({
  root: {},
  listItem: {
    border: `1px solid ${theme.palette.facet.lightGray}`,
  },
  icon: {
    color: theme.palette.facet.accentBlue,
  },
}))(DocumentList);
